// extracted by mini-css-extract-plugin
export default {"block2_container":"index_block2_container_Qcej4 clearfix"};